import { ArrowBackIosRounded } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LineClampTypography from 'src/components/common/ui/LineClampTypography';
import { FlexContainer } from 'src/components/styles';
import CartLinkButton from 'src/features/cart/presentation/components/CartLinkButton';

type PageHeaderProps = {
  title?: string;
  showCart?: boolean;
  onBack?: () => void;
  top?: number;
};

export default function PageHeader({
  title,
  showCart,
  onBack,
  top,
}: PageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    const el = document.querySelector('.page-header');
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
      { threshold: [1], rootMargin: '-34px 0px 0px 0px' }
    );

    if (el) observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Box
      width="100%"
      sx={{
        background: '#fff',
        pr: 2,
        '& .is-pinned': {
          pt: 4,
        },
      }}
      position={'sticky'}
      top={top || 0}
      zIndex={(theme) => theme.zIndex.appBar}
    >
      <Box
        display="flex"
        className="page-header"
        sx={{ transition: 'padding 0.2s' }}
      >
        <Box width="44px">
          <IconButton
            sx={{ paddingLeft: 0.5, paddingRight: 1.5 }}
            onClick={handleBack}
          >
            <ArrowBackIosRounded />
          </IconButton>
        </Box>
        <Box width="100%" overflow="hidden" flexWrap="nowrap">
          <LineClampTypography
            typographyProps={{
              variant: 'h5',
              fontWeight: 'fontWeightBold',
              pt: 1.1,
            }}
            lines={1}
            content={title ?? ''}
            disableFulltextToggle
          />
        </Box>
        {showCart ? (
          <Box width={'calc(100% * 2 / 12)'} ml="auto">
            <FlexContainer
              height="100%"
              justifyContent="flex-end"
              alignItems="center"
            >
              <CartLinkButton />
            </FlexContainer>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
